import http from 'services/http';
import type { TrashType } from './types';

/** Brings a just-deleted item back (the X-Organization-Id header is added by the client). */
export async function restoreTrashItem(type: TrashType, id: string): Promise<void> {
  await http.request.post(`/api/trash/${type}/${encodeURIComponent(id)}/restore`);
}
